/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ComprehensionCheckIcon = /*#__PURE__*/ createSvgIcon(
  'ComprehensionCheckIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.996 18c-.414 0-.767-.147-1.059-.44A1.45 1.45 0 018.5 16.5h3c0 .417-.147.77-.442 1.063A1.456 1.456 0 019.996 18zm-2.24-2.5a.738.738 0 01-.537-.214.714.714 0 01-.219-.532c0-.21.072-.39.215-.535A.719.719 0 017.75 14h4.495c.212 0 .391.072.537.214.146.143.219.32.219.532 0 .21-.072.39-.215.535a.719.719 0 01-.534.219H7.756zM6.687 13a5.355 5.355 0 01-1.99-2.135A6.127 6.127 0 014 8c0-1.667.583-3.083 1.75-4.25C6.917 2.583 8.333 2 10 2c1.667 0 3.083.583 4.25 1.75C15.417 4.917 16 6.333 16 8a6.127 6.127 0 01-.698 2.865A5.355 5.355 0 0113.312 13H6.689zm.48-1.5h5.666a4.49 4.49 0 001.23-1.563A4.442 4.442 0 0014.5 8c0-1.255-.436-2.318-1.308-3.19-.872-.874-1.934-1.31-3.187-1.31s-2.318.436-3.193 1.31C5.938 5.681 5.5 6.744 5.5 8c0 .68.146 1.326.438 1.938A4.489 4.489 0 007.167 11.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ComprehensionCheckIcon;
